export const ERROR_CODES = {
    0: "Error Code 0: No error",
    1: "Error Code 1: Creation failed (fingerprint reader not correctly installed or driver files error)",
    2: "Error Code 2: Function failed (wrong type of fingerprint reader or not correctly installed)",
    3: "Error Code 3: Internal (invalid parameters to sensor API)",
    5: "Error Code 5: DLL load failed",
    6: "Error Code 6: DLL load failed for driver",
    7: "Error Code 7: DLL load failed for algorithm",
    51: "Error Code 51: System file load failure",
    52: "Error Code 52: Sensor chip initialization failed",
    53: "Error Code 53: Sensor line dropped",
    54: "Error Code 54: Timeout",
    55: "Error Code 55: Device not found",
    56: "Error Code 56: Driver load failed",
    57: "Error Code 57: Wrong image",
    58: "Error Code 58: Lack of bandwidth",
    59: "Error Code 59: Device busy",
    60: "Error Code 60: Cannot get serial number of the device",
    61: "Error Code 61: Unsupported device",
    101: "Error Code 101: Very low minutiae count",
    102: "Error Code 102: Wrong template type",
    103: "Error Code 103: Invalid template",
    104: "Error Code 104: Invalid template",
    105: "Error Code 105: Could not extract features",
    106: "Error Code 106: Match failed",
    1000: "Error Code 1000: No memory",
    2000: "Error Code 2000: Internal error",
    3000: "Error Code 3000: Internal error extended",
    4000: "Error Code 4000: Invalid parameter passed to service",
    6000: "Error Code 6000: Certificate error cannot decode",
    10001: "Error Code 10001: License error",
    10002: "Error Code 10002: Invalid domain",
    10003: "Error Code 10003: License expired",
    10004: "Error Code 10004: WebAPI may not have received the origin header from the browser",
  };
  